import type { IHttpClientService } from "@/shared/services/http_client/interfaces/IHttpClientService.ts";
import type { INotificationsRepository } from "@/app/header/notifications/interfaces/INotificationsRepository";
import type { NotificationsFilterModel } from "@/app/header/notifications/models/NotificationsFilterModel";
import type {
  NotificationsPaginatedModel,
  NotificationsTotalNotReadModel,
} from "@/app/header/notifications/models/NotificationsModel";

export class NotificationsRepository implements INotificationsRepository {
  private readonly BASE_URL: string = "/users";
  private readonly URL: string = "/notifications";

  constructor(private readonly httpClientService: IHttpClientService) {}

  async getAllPaginatedNotifications(
    userId: string | number,
    filter: NotificationsFilterModel,
  ): Promise<NotificationsPaginatedModel> {
    const params = new URLSearchParams({
      size: String(filter.size),
      page: String(filter.page),
    });

    return await this.httpClientService.get(
      `${this.BASE_URL}/${userId}${this.URL}/pageable?${params.toString()}`,
    );
  }

  async getNotificationsNotRead(userId: string | number): Promise<NotificationsTotalNotReadModel> {
    return await this.httpClientService.get(`${this.BASE_URL}/${userId}${this.URL}/total-not-read`);
  }

  async markAllNotifications(userId: string | number): Promise<void> {
    return await this.httpClientService.put(`${this.BASE_URL}/${userId}${this.URL}`);
  }

  async markNotifications(userId: string | number, notificationId: number): Promise<void> {
    return await this.httpClientService.put(
      `${this.BASE_URL}/${userId}${this.URL}/${notificationId}`,
    );
  }
}
